/**
 * Hydrate les images de galerie produit neutralisées par snippets/media.liquid
 * (src/srcset -> data-defer-src/data-defer-srcset).
 *
 * Objectif : ne pas télécharger les ~17 slides cachées au chargement initial
 * (Chrome précharge les images d'un carrousel horizontal malgré loading="lazy"),
 * mais les rendre disponibles dès le premier signe d'interaction, avant que
 * l'utilisateur n'ait pu changer de slide.
 *
 * Déclencheurs :
 *  - au repos, après le chargement : les 2 slides voisines de la vedette seulement
 *    (voir hydrateNeighbours) ; sans ça la slide 2 arrive vide dans le viewport et
 *    l'image ne se peint qu'au bout de ~635 ms mesurées en Fast 3G, ce qui se voit
 *    comme un flash au premier glissement.
 *  - première interaction : touchstart / pointerdown / keydown / wheel -> tout le reste
 *  - sécurité : changement de classe sur une slide (Flickity sélectionne une
 *    nouvelle slide par programme, ex. clic sur une variante qui change le média)
 */
(function () {
  'use strict';

  var SELECTOR = 'img[data-defer-src], img[data-defer-srcset]';
  var hydrated = false;
  var observer = null;

  function hydrateImg(img) {
    var srcset = img.getAttribute('data-defer-srcset');
    var src = img.getAttribute('data-defer-src');
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-defer-srcset');
    }
    if (src) {
      img.setAttribute('src', src);
      img.removeAttribute('data-defer-src');
    }
  }

  function hydrateAll() {
    if (hydrated) return;
    hydrated = true;

    var imgs = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < imgs.length; i += 1) hydrateImg(imgs[i]);

    ['touchstart', 'pointerdown', 'keydown', 'wheel'].forEach(function (name) {
      window.removeEventListener(name, hydrateAll);
    });
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  /*
    Voisines de la slide vedette, hydratées au repos.

    Le différé existe pour ne pas télécharger les ~17 slides au chargement. Mais attendre
    l'interaction pour la slide suivante revient à demander l'image *pendant* le glissement :
    la slide entre dans le viewport vide et reste grise le temps du téléchargement.

    On hydrate donc les voisines immédiates une fois la page chargée et le thread libre,
    hors de la fenêtre critique du LCP. 2 de chaque côté en connexion normale, 1 seule en
    connexion lente ou mode économie de données. Le reste attend toujours l'interaction.
  */
  function hydrateNeighbours() {
    if (hydrated) return;

    var slides = document.querySelectorAll('[data-product-slide]');
    if (!slides.length) return;

    var featured = 0;
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i].className.indexOf('media--hidden') === -1) {
        featured = i;
        break;
      }
    }

    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var slow = Boolean(conn && (conn.saveData || /^(slow-2g|2g|3g)$/.test(conn.effectiveType || '')));
    var span = slow ? 1 : 2;

    for (var offset = -span; offset <= span; offset += 1) {
      var slide = slides[featured + offset];
      if (!slide || offset === 0) continue;

      var imgs = slide.querySelectorAll(SELECTOR);
      for (var j = 0; j < imgs.length; j += 1) {
        // `loading="lazy"` sur une slide hors du viewport horizontal laisse le
        // téléchargement à la discrétion du navigateur : on le force, en priorité basse.
        imgs[j].setAttribute('fetchpriority', 'low');
        imgs[j].setAttribute('decoding', 'async');
        imgs[j].setAttribute('loading', 'eager');
        hydrateImg(imgs[j]);
      }
    }
  }

  function scheduleNeighbours() {
    var run = function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(hydrateNeighbours, {timeout: 2500});
      } else {
        setTimeout(hydrateNeighbours, 1200);
      }
    };

    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, {once: true});
  }

  function init() {
    if (!document.querySelector(SELECTOR)) return;

    scheduleNeighbours();

    ['touchstart', 'pointerdown', 'keydown', 'wheel'].forEach(function (name) {
      window.addEventListener(name, hydrateAll, {passive: true, once: true});
    });

    // Sélection de slide par programme (changement de variante, etc.).
    // Flickity marque la slide vedette « is-selected » dès son initialisation : cette
    // mutation-là ne doit PAS déclencher l'hydratation (sinon les 17 images partent au
    // chargement et tout le différé est perdu). On n'hydrate que si une slide AUTRE que
    // la vedette initiale devient sélectionnée.
    if ('MutationObserver' in window) {
      var slides = document.querySelectorAll('[data-product-slide]');
      if (slides.length) {
        var featured = null;
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i].className.indexOf('media--hidden') === -1) {
            featured = slides[i];
            break;
          }
        }
        observer = new MutationObserver(function (mutations) {
          for (var m = 0; m < mutations.length; m += 1) {
            var el = mutations[m].target;
            if (el !== featured && el.className.indexOf('is-selected') !== -1) {
              hydrateAll();
              return;
            }
          }
        });
        for (var j = 0; j < slides.length; j += 1) {
          observer.observe(slides[j], {attributes: true, attributeFilter: ['class']});
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once: true});
  } else {
    init();
  }
})();
